import Core from '../plugin-core-system/core.class.js';
import TranslatedLang from '../helper/translated-lang.helper.js';

export default class CsExternalLinks extends Core {

  static options = {
    classNameForOnlyScreenreaderText: 'h-visible-only-for-screenreader',
    globalWrapperSelector: '.js-global-wrapper'
  };

  /**
   * Appends a screenreader-only text to an external link if not already present
   */
  initExternalLinks() {
    const base = this;
    if (!base.el.querySelector('.' + base.options.classNameForOnlyScreenreaderText)) { // Check if span already exists
      const screenReaderText = document.createElement('span');
      screenReaderText.className = base.options.classNameForOnlyScreenreaderText;

      const translatedStringObject = TranslatedLang.translatedLangConfig('links', 'postFixString');
      const postfixText = translatedStringObject.postFixString.external;

      screenReaderText.textContent = ` (${postfixText})`;
      base.el.appendChild(screenReaderText);
    }
  }

  init() {
    this.initExternalLinks();
  }
}
